export default __webpack_public_path__ + "static/media/inmobiliaria-ikiga.07816764.png";